\<template>
  <div>

    <div class="wrapper-content w-100 position-relative pt-4">
      <div>

        <LmSuperPowerSelectV2 label="Origen de datos" placeholder="Origen de datos" :options="dataOrigin"
          v-model="dataOriginSelected" @input="inputOriginData" :defaultValue="dataOriginSelected" v-show="!isOnEditMode"  />
        <div v-if="dataOriginSelected || isOnEditMode">
          <LmTextInput label="Alias" v-model="form.alias" />

          <LmTextInput label="Título del listado" v-model="form.titleList" />

          <div class="bg-secondary text-light py-2 mt-3 rounded-top" @click="isSearch=!isSearch">
            <div class=" pl-2 w-100 position-relative">
              <font-awesome-icon :icon="isSearch ? 'angle-down' : 'angle-up'" /> Búsqueda inicial
            </div>
          </div>
          <div class=" border border-1 border-secondary p-4" v-show="isSearch">

            <div class="mt-2">
              <LmTextInput label="Búsqueda inicial" v-model="form.gqlVariables.q" />
              <LmSuperPowerSelectV2 label="Ordenar por" placeholder="_score" :options="dataSort"
          v-model="dataSortSelected" @input="inputSortData" :defaultValue="dataSortSelected"  />

              <LmButton type="button" buttonClass="btn-primary" value="Agregar búsqueda"
                lmButtonRootWrapperClass="d-inline-block mr-1 mt-2 mb-0" lmButtonWrapperClass="col"
                @click.native="addSearch" />
            </div>
          </div>

          <div class="bg-secondary text-light py-2 mt-3 rounded-top" @click="isColumns=!isColumns">
            <div class=" pl-2 w-100 position-relative">
              <font-awesome-icon :icon="isColumns ? 'angle-down' : 'angle-up'" /> Columnas
            </div>
          </div>
          <div class=" border border-1 border-secondary p-4" v-if="isColumns">

            <div v-for="(item, index) in form.items" :key="index">
              <input type="checkbox" :value="item.name" :id="'col-'+index" name="itemsColumns"
                v-model="form.searchOnFieldsToSelected" checked class="mr-2"><label
                :for="'col-'+index">{{ item.name }}</label>
            </div>

            <LmButton type="button" buttonClass="btn-primary" value="Aplicar columnas"
              lmButtonRootWrapperClass="d-inline-block mr-1 mt-3 mb-0" lmButtonWrapperClass="col"
              @click.native="addColumns" />

          </div>

          <div class="bg-secondary text-light py-2 mt-3 rounded-top" @click="isButtons=!isButtons">
            <div class=" pl-2 w-100 position-relative">
              <font-awesome-icon :icon="isButtons ? 'angle-down' : 'angle-up'" /> Botones - {{ form.buttonLinks.length }}
            </div>
          </div>
          <div class=" border border-1 border-secondary p-4" v-if="isButtons">
            <LmTextInput v-model="buttons.value" label="Value" placeholder="Nuevo formulario" />

            <LmTextInput v-model="buttons.to" label="To" placeholder="/listbuilderui/" />

            <label for="">Color</label>

            <swatches
      v-model="colorButton"
      :swatches="swatches"
      :trigger-style="{ width: '36px', height: '36px', borderRadius: '5px', 'box-shadow': '0px 0px 2px #ccc' }"
      :swatch-style="{ width: '36px', height: '36px', borderRadius: '5px', 'box-shadow': '0px 0px 2px #ccc' }"
      popover-to="left"
      class="d-block"
    ></swatches>

            <LmButton type="button" buttonClass="btn-primary" value="Agregar botón"
              lmButtonRootWrapperClass="d-inline-block mr-1 mt-3 mb-3" lmButtonWrapperClass="col"
              @click.native="addButonLink" />

            <div v-for="(item, index) in form.buttonLinks" :key="index">

              <LmButton type="button" :buttonClass="item.buttonClass" :value="item.value"
                lmButtonRootWrapperClass="d-inline-block  mt-3 mb-0" lmButtonWrapperClass="col" /> <span
                class="mx-2">|</span>
              <font-awesome-icon icon="trash" @click="deleteButtons(index)" />
            </div>
          </div>

          <div class="bg-secondary text-light py-2 mt-3 rounded-top" @click="isPages=!isPages">
            <div class=" pl-2 w-100 position-relative">
              <font-awesome-icon :icon="isPages ? 'angle-down' : 'angle-up'" /> Paginado - {{ form.page }} - {{ form.perpage }}
            </div>
          </div>

          <div class=" border border-1 border-secondary p-4" v-if="isPages">
            <LmTextInput label="Page" v-model="form.page"  />
            <LmTextInput label="Per Page" v-model="form.perpage"  />
            <LmButton type="button" buttonClass="btn-primary" value="Aplicar pages"
              lmButtonRootWrapperClass="d-inline-block mr-1 mt-3 mb-0" lmButtonWrapperClass="col"
              @click.native="addPages" />
          </div>

          <div class="bg-secondary text-light py-2 mt-3 rounded-top" @click="isActions=!isActions">
            <div class=" pl-2 w-100 position-relative">
              <font-awesome-icon :icon="isActions ? 'angle-down' : 'angle-up'" /> Acciones -
              {{ form.lmPathActions.length }}
            </div>
          </div>

          <div class=" border border-1 border-secondary p-4" v-if="isActions">

            <LmTextInput ref="to" v-model="action.to" label="to" />

            <LmTextInput ref="tooltip" v-model="action.tooltip" label="tooltip" placeholder="Editar" />

            <LmTextInput ref="fontAwesomeIcon" v-model="action.fontAwesomeIcon" label="fontAwesomeIcon"
              placeholder="edit" />
              Icons: <a href="https://fontawesome.com/icons?d=gallery" target="_blank" class="mt-0 mb-4 d-block">https://fontawesome.com/icons?d=gallery</a>

            <LmButton type="button" buttonClass="btn-primary" value="Agregar action"
              lmButtonRootWrapperClass="d-inline-block mr-1 mt-2 mb-0" lmButtonWrapperClass="col"
              @click.native="addActions" />

            <div class="mt-4 mb-2">
              <div v-for="(item, index) in form.lmPathActions" :key="index">
                <font-awesome-icon :icon="item.fontAwesomeIcon" /> {{ item.tooltip }} |
                <font-awesome-icon icon="trash" @click="deleteActions(index)" />
              </div>
            </div>
          </div>

          <div class="bg-secondary text-light py-2 mt-3 rounded-top" @click="isMode=!isMode">
            <div class=" pl-2 w-100 position-relative">
              <font-awesome-icon :icon="isMode ? 'angle-down' : 'angle-up'" /> Modo
            </div>
          </div>

          <div class=" border border-1 border-secondary p-4" v-if="isMode">
            <b-form-radio-group
              v-model="form.mode"
              :options="modes"
              class="mb-2"
              value-field="item"
              text-field="name"
              disabled-field="notEnabled"
            ></b-form-radio-group>
          </div>

          <LmButton type="submit" buttonClass="btn-primary" :value="$t('Save')"
            lmButtonRootWrapperClass="d-inline-block mr-1 mt-3 mb-2" lmButtonWrapperClass="col"
            @click.native="submit" :isProcessing="isProcessing" />

            <div class="border d-block mt-3 p-3 mb-0 " v-if="this.currentID">
            <router-link :to="{ path: '/listbuilder/view/'+ this.currentID }" class="d-block text-monospace">
            👉 Ver el último listado cargado
            </router-link>
            <router-link :to="{ path: '/listbuilder/view/' + this.listadoID }" class="d-block mt-1 text-monospace">
              <font-awesome-icon icon="list-alt" class="" /> Listado de Listados
            </router-link>
            </div>

        </div>
      </div>
    </div>

    <div class="bg-primary text-light  py-2 mt-4 mb-4">
      <div class="wrapper-content w-100 position-relative my-1">
        <font-awesome-icon icon="list" class="mr-1" /> Preview del listado
      </div>
    </div>

    <LmListV2 v-if="dataOriginSelected" ref="LmListV2" :isGraphql="isGraphql"
      :gqlField="form.gqlField" :gqlVariables="form.gqlVariables" :gqlQuery="form.gqlQuery"
      :arrayEmplyItems="arrayEmplyItems" :searchOnFieldsSelected="form.searchOnFieldsSelected"
      :searchOnFieldsToSelected="form.searchOnFieldsToSelected" :mode="form.mode" :allAvailableFields="form.fields" :isOnEditMode="true" :key="key" />

    <LmError v-if="!dataOriginSelected" title="Seleccione el origen de datos"
      subtitle="Comience seleccionando el origen de datos para previsualizar la tabla" />

  </div>
</template>

<script>
import gql from 'graphql-tag'
import _ from 'lodash'
import Swatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'
import commonsApi from '@/api/commons'

import LmListV2 from '@/components/LmListV2.vue'
import LmTextInput from '@/components/form/elements/LmTextInput.vue'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2.vue'
import LmError from '@/components/LmError.vue'
import LmButton from '@/components/form/elements/LmButton.vue'
import lmToasts from '@/mixins/lmToasts.js'

export default {
  mixins: [lmToasts],
  components: {
    LmListV2,
    LmTextInput,
    LmSuperPowerSelectV2,
    LmError,
    LmButton,
    Swatches
  },
  props: {
    isGraphql: {
      type: Boolean,
      default: false
    },
    gqlQuery: {
      type: String,
      default: ''
    },
    gqlSchema: {
      type: String,
      default: ''
    },
    gqlField: {
      type: String,
      default: ''
    },
    gqlVariables: {
      type: Object
    },
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dataOrigin: [],
      dataOriginSelected: '',
      dataSchemaGraphql: '',
      dataSort: [],
      isLoading: false,
      isActions: false,
      isSearch: false,
      isColumns: false,
      isButtons: false,
      isPages: false,
      isMode: false,
      isProcessing: false,
      currentID: '',
      listadoID: '600f360aed518edeaa897095',
      dataSortSelected: {},
      defaultDataSortSelected: '',
      arrayEmplyItems: [],
      swatches: [{ color: '#007bff' }, { color: '#6c757d' }, { color: '#17a2b8' }, { color: '#28a745' }, { color: '#ffc107' }, { color: '#dc3545' }, { color: '#343a40' }],
      colorButton: '#17a2b8',
      buttons: {
        value: '',
        to: '',
        buttonClass: ''
      },
      action: {
        to: '/listbuilder/edit/:_id',
        tooltip: '',
        fontAwesomeIcon: ''
      },
      count: 0,
      key: 0,
      modes: [
        { item: { table: true, map: false }, name: 'Listado' },
        { item: { table: false, map: true }, name: 'Mapa' }
      ],
      form: {
        alias: '',
        titleList: '',
        gqlField: '',
        gqlQuery: '',
        gqlVariables: {
          q: '*',
          sort: '_score',
          page: 1
        },
        lmPathActions: [],
        searchOnFieldsSelected: [],
        searchOnFieldsToSelected: [],
        allAvailableFields: [],
        fields: [],
        newFields: [],
        items: {},
        buttonLinks: [],
        page: 1,
        perpage: 10,
        mode: {
          table: true,
          map: false
        }
      }

    }
  },
  computed: {
    computedButtonClass: function () {
      let buttonClass = ''
      if (this.colorButton === '#007bff') buttonClass = 'btn-primary'
      if (this.colorButton === '#6c757d') buttonClass = 'btn-secondary'
      if (this.colorButton === '#17a2b8') buttonClass = 'btn-info'
      if (this.colorButton === '#28a745') buttonClass = 'btn-success'
      if (this.colorButton === '#ffc107') buttonClass = 'btn-warning'
      if (this.colorButton === '#dc3545') buttonClass = 'btn-danger'
      if (this.colorButton === '#343a40') buttonClass = 'btn-dark'

      return buttonClass
    }
  },

  methods: {
    addButtonClass (color) {
      if (color === '#007bff') color = 'btn-primary'
      if (color === '#6c757d') color = 'btn-secondary'
      if (color === '#17a2b8') color = 'btn-info'
      if (color === '#28a745') color = 'btn-success'
      if (color === '#ffc107') color = 'btn-warning'
      if (color === '#dc3545') color = 'btn-danger'
      if (color === '#343a40') color = 'btn-dark'
      return color
    },
    inputSortData () {
      let sort = this.dataSortSelected?.name
      this.form.gqlVariables.sort = sort
      this.key++
      this.initialOriginData()
    },
    inputOriginData () {
      this.form.alias = ''
      if (!this.isOnEditMode) this.form.titleList = ''
      this.form.lmPathActions = []
      this.form.buttonLinks = []
      this.form.page = 1
      this.form.perpage = 10
      if (!this.isOnEditMode) this.form.gqlVariables.q = '*'
      if (!this.isOnEditMode) this.form.gqlVariables.sort = '_score'
      this.form.fields = []
      this.count = 0
      this.key++
      if (Object.keys(this.$route.query).length > 0) {
        this.$router.replace({})
      }

      this.initialOriginData('inputOriginData')
    },
    addPages () {
      this.initialOriginData()
    },
    addButonLink () {
      if (this.buttons?.to && this.buttons?.value) {
        this.buttons.buttonClass = this.computedButtonClass

        this.form.buttonLinks.push({ ...this.buttons })
        this.buttons.to = ''
        this.buttons.value = ''
        this.initialOriginData()
      }
    },
    deleteButtons (index) {
      this.form.buttonLinks.splice(index, 1)
      this.initialOriginData()
    },
    addColumns () {
      let newOrderedArray = []
      let searchOnFieldsToSelected = this.form.searchOnFieldsToSelected

      _.forEach(this.form.items, function (value, key) {
        if (searchOnFieldsToSelected.includes(value.name)) newOrderedArray.push(value.name)
      })

      this.form.searchOnFieldsToSelected = newOrderedArray
      this.key++
      this.initialOriginData('addColumns')
    },
    addSearch () {
      this.form.gqlVariables.q = this.form.gqlVariables?.q ? this.form.gqlVariables.q : '*'
      this.key++
      this.initialOriginData()
    },
    async addActions () {
      if (this.action?.to && this.action?.tooltip && this.action?.fontAwesomeIcon) {
        this.form.lmPathActions.push({ ...this.action })
        this.action.tooltip = ''
        this.action.fontAwesomeIcon = ''
        this.key++
        this.initialOriginData()
      }
    },
    deleteActions (index) {
      this.form.lmPathActions.splice(index, 1)
      this.initialOriginData()
    },
    async submit () {
      try {
        if (this.isOnEditMode) {
          // const response = await commonsApi.axiosPutWrapper(`listbuilder/${this.$route.params.id}`, this.form)
          // this.currentID = response.data._id
          // this.lmToastSuccessInternalLink(`/listbuilder/preview/${this.currentID}`, 'Puedes ver el formulario aquí', 'Se guardó exitosamente')
          this.initialOriginData()
          const response = await commonsApi.axiosPutWrapper(`listbuilder/${this.$route.params.id}`, this.form)
          this.currentID = response.data._id
          this.lmToastSuccessInternalLink(`/listbuilder/view/${this.currentID}`, 'Puedes ver el listado aquí', 'Se guardó exitosamente')
        } else {
          this.isProcessing = true
          const response = await commonsApi.axiosPostWrapper('listbuilder/create', this.form)
          this.currentID = response.data._id
          this.lmToastSuccessInternalLink(`/listbuilder/view/${this.currentID}`, 'Puedes ver el listado aquí', 'Se guardó exitosamente')
          // const response = await commonsApi.axiosPostWrapper('listbuilder/create', this.form)
          // this.currentID = response.data._id
          // this.lmToastSuccessInternalLink(`/listbuilder/preview/${this.currentID}`, 'Puedes ver el  formulario aquí', 'Se guardó exitosamente')
        }
      } finally {
        this.isProcessing = false
        // this.$router.push('/listbuilder')
      }
    },
    changeHandler () {
      this.$refs.LmListV2.titleList = this.form.titleList
    },
    initialOriginData (loadFromMethod) {
      let sort = ''
      let items = ''
      let item = ''
      let fieldSelected = []
      this.arrayEmplyItems = []

      // get name of field sort
      _.forEach(this.dataOriginSelected.args, function (value, key) {
        if (value.type.ofType && value.type.ofType.name.substr(-8) === 'SortEnum') {
          sort = value.type.ofType.name
        }
      })

      const table = _.filter(this.dataOriginSelected.fields, ['name', 'table'])
      items = _.filter(table[0].type.fields, ['name', 'items'])

      items = items[0].type.ofType.fields
      this.form.items = items

      let emplyItems = {}
      _.forEach(items, function (value, key) {
        item += value.name + ' '
        emplyItems[value.name] = ' '
        fieldSelected.push(value.name)
      })
      this.arrayEmplyItems.push(emplyItems)

      items = item

      if (loadFromMethod === 'addColumns') {
        items = this.form.searchOnFieldsToSelected.toString()
        items = items.replaceAll(',', ' ')
      }

      if (loadFromMethod === 'inputOriginData') {
        this.form.searchOnFieldsSelected = fieldSelected
        this.form.searchOnFieldsToSelected = fieldSelected
        this.form.gqlVariables.q = '*'
      }

      let lmPathActions = JSON.stringify(this.form.lmPathActions)
      lmPathActions = lmPathActions.replace(/"([^"]+)":/g, '$1:')

      let buttonLinks = JSON.stringify(this.form.buttonLinks)
      buttonLinks = buttonLinks.replace(/"([^"]+)":/g, '$1:')

      this.form.gqlField = this.dataOriginSelected.name
      let enumDataSort = this.dataOriginSelected.args[2].type.ofType.enumValues

      let dataSort = []

      _.forEach(enumDataSort, function (value, key) {
        dataSort.push({ id: value.name, name: value.name })
      })

      if (!this.isOnEditMode) this.dataSort = enumDataSort
      if (this.count === 1 && this.isOnEditMode) this.dataSort = dataSort

      if (this.count === 1 && !this.isOnEditMode) {
        this.form.allAvailableFields = this.form.fields
      }

      this.form.newFields = this.form.fields

      const valuesToRemove = this.form.searchOnFieldsToSelected
      const filteredItems = this.form.newFields.filter(item => valuesToRemove.includes(item.key))
      this.form.newFields = filteredItems

      if (this.form.searchOnFieldsToSelected.length > this.form.newFields.length && this.form.newFields.length > 0) {
        const valuesToAdd = this.form.searchOnFieldsToSelected
        const filteredItems = this.form.allAvailableFields.filter(item => valuesToAdd.includes(item.key))
        //
        this.form.newFields = filteredItems
      }

      // queryGraphql
      // console.log(JSON.stringify(this.sortSelected))

      this.form.gqlQuery = `query($page:Int, $q:String, $sort:[${sort}]) {
  ${this.form.gqlField}(
    titleList: ${this.form?.titleList ? '"' + this.form.titleList + '"' : '" "'}
    q: $q
    perPage: ${this.form.perpage ? this.form.perpage : 10}
    page: $page
    sort: $sort
    opts: {
      lenient: true
    }
lmPathActions: ${this.form.lmPathActions.length > 0 ? lmPathActions : '[]'}
buttonLinks: ${this.form.buttonLinks.length > 0 ? buttonLinks : '[]'}
  ) {
    count
    searcher
    tableItemsTotal
    titleList
    table {
      items {
        ${this.form.searchOnFieldsToSelected}
      }
      fields {
        key
        label
        sortable
      }
    }
    buttons
    pagination
  }
}`

      this.form.gqlVariables = {
        q: this.form.gqlVariables.q,
        sort: this.form.gqlVariables.sort ? this.form.gqlVariables.sort : '_score',
        page: this.form.page ? this.form.page : 1
      }

      this.count++
    },

    async getListValues () {
      try {
        this.isDataProcessing = true
        const endPoint = await commonsApi.axiosGetWrapper(`listbuilder/${this.$route.params.id}`)
        this.form.gqlQuery = await endPoint.data.gqlQuery
        this.dataOriginSelected = await endPoint.data.gqlField
        this.form.gqlVariables = await endPoint.data.gqlVariables
        this.dataSortSelected = { id: endPoint.data.gqlVariables.sort, name: endPoint.data.gqlVariables.sort }
        this.form.alias = await endPoint.data.alias
        this.form.titleList = await endPoint.data.titleList
        this.form.gqlField = await endPoint.data.gqlField
        this.form.buttonLinks = await endPoint.data.buttonLinks
        this.form.lmPathActions = await endPoint.data.lmPathActions
        this.form.searchOnFieldsSelected = await endPoint.data.searchOnFieldsSelected
        this.form.searchOnFieldsToSelected = await endPoint.data.searchOnFieldsToSelected
        this.form.allAvailableFields = await endPoint.data.allAvailableFields
        this.form.fields = await endPoint.data.fields
        this.form.mode = await endPoint.data.mode

        this.initialOriginData('getListValues')
      } catch (error) {
        console.log(error)
      } finally {
        this.isDataProcessing = false
      }
    }

  },
  async mounted () {
    if (this.isGraphql) {
      try {
        this.dataSchemaGraphql = await this.$apollo.query({ query: gql`${this.gqlSchema}` })
        let initialDataOrigin = []
        // get origin data and args
        _.forEach(this.dataSchemaGraphql.data.__schema.queryType.fields, function (value, key) {
          initialDataOrigin.push({
            id: key,
            args: value.args,
            name: value.name,
            fields: value.type.fields
          })
        })
        this.dataOrigin = initialDataOrigin
        if (this.isOnEditMode) {
          this.getListValues()
        }
      } catch (e) {
        console.log('graphQlAllErrors:', JSON.stringify(e))
        console.log('graphQlNetworkError:', JSON.stringify(e.networkError))
        console.log('graphQlErrors:', JSON.stringify(e.graphQLErrors))
      }
    }
  },
  beforeUpdate () {
    if (this.form.titleList) this.changeHandler()
  }
}
</script>

<style>

</style>
